/* ==========================================================================
   Sad Boy Saga — match-3 shoebox SMS pop-up (2026-10-24, Jalen; option 7 of
   clients/sad_boy_saga/docs/popup_options_2026-10-24.html)

   Flow:  trigger (delay / desktop exit intent) -> the shopper opens any 3 of
          9 shoeboxes -> the same pair comes out of all 3 (the first box picks
          the pair, the next two always match it) -> 10% off shows (EVERY
          visitor gets the same one) -> "Claim" reveals the Postscript pop-up,
          which collects the phone number and texts the code.

   Postscript hold and lifecycle (once per visitor, cooldown after a dismiss,
   reopen tab, subscriber skip, scroll lock, instant hand-off) are a port of
   fraternal theme_variant_a assets/frt-slot-popup.js (itself Nasty Rugs'
   paint-the-mirror, One Chance's stopwatch, Gibbs's Krazy Ambitions slot).
   Config: window.SBS_MATCH_CFG, written by snippets/sbs-match-config.liquid.

   SBS-specific: assets/sbs-app.js has a Postscript "safety valve" that force-
   hides any Postscript pop-up after 8 s (the 2026-10-02 checkout blocker).
   Claim sets window.sbsPsHandoff so the valve leaves the phone step alone,
   and clears the display:none the valve may already have put on the frame.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-sbs-match]');
  if (!root || typeof root.showModal !== 'function') return;

  var c0 = window.SBS_MATCH_CFG || {};
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  var cfg = {
    enabled:      c0.enabled === true,
    popupId:      String(c0.popupId || '').trim(),
    delay:        num(c0.delay, 5),
    exitIntent:   c0.exitIntent === true,
    cooldownDays: num(c0.cooldownDays, 7),
    force:        /[?&]sbs_match=1\b/.test(location.search)
  };
  var ready = cfg.enabled && !!cfg.popupId;

  var KEY = 'sbs_match_v1';
  function readState() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function writeState(patch) {
    try { var s = readState(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function emit(action, extra) {
    var d = { action: action }; if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('sbs:match-popup', { detail: d })); } catch (e) {}
  }

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function later(ms, fn) { return setTimeout(fn, reduceMotion ? 0 : ms); }

  /* ---------------------------------------------------------------- gating */
  function fromOurTexts() { return /utm_source=postscript/i.test(location.search); }
  function suppressedLocally() {
    if (cfg.force) return false;
    if (!ready || fromOurTexts()) return true;
    var s = readState();
    if (s.claimed) return true;
    if (s.dismissed && Date.now() - s.dismissed < cfg.cooldownDays * 864e5) return true;
    return false;
  }
  // getSubscriberId may be sync or a promise depending on the SDK build.
  function isSubscriber(cb) {
    var ps = window.postscript, r;
    if (!ps || typeof ps.getSubscriberId !== 'function') return cb(false);
    try { r = ps.getSubscriberId(); } catch (e) { return cb(false); }
    if (r && typeof r.then === 'function') {
      var done = false;
      r.then(function (id) { if (!done) { done = true; cb(!!id); } }, function () { if (!done) { done = true; cb(false); } });
      setTimeout(function () { if (!done) { done = true; cb(false); } }, 1500);
    } else cb(!!r);
  }

  /* ------------------------------------------------------- Postscript hold
     html.sbs-ps-hold (set in <head> by snippets/sbs-match-hold.liquid) keeps Postscript's frame invisible and
     click-through while unclaimed. Once the boxes match we open OUR configured pop-up ourselves, still hidden, so
     it is fully drawn before Claim; Claim reveals it. */
  var holding = document.documentElement.classList.contains('sbs-ps-hold');
  function holdPostscript() { if (!holding) { holding = true; document.documentElement.classList.add('sbs-ps-hold'); } }
  function releaseHold() { holding = false; document.documentElement.classList.remove('sbs-ps-hold'); }
  function unhideFrame() {
    var c = document.getElementById('ps__widget_container');
    if (c && c.style.display === 'none') c.style.display = '';
  }
  var preopened = false;
  function psOpen() {
    var ps = window.postscript;
    if (!cfg.popupId || !ps || !ps.popups || typeof ps.popups.open !== 'function') return false;
    window.sbsPsHandoff = true; unhideFrame();
    try { ps.popups.open(cfg.popupId, { activePopupBehavior: 'ALWAYS_DISMISS', respectPopupStatus: true }); return true; } catch (e) { return false; }
  }
  function preopenPostscript() { if (holding && !preopened && psOpen()) preopened = true; }

  // Never stack on the cart or nav drawer, the free-pair picker, the size guide/picker, or another dialog.
  function somethingElseOpen() {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== root) return true;
    if (document.querySelector('.cart-drawer.open, .nav-drawer.open, .filter-drawer.open, .cart-overlay.open, .size-modal.open')) return true;
    var fs = document.querySelector('[data-fs-overlay]'); if (fs && !fs.hidden) return true;
    var picker = document.querySelector('[data-ctf-picker]'); if (picker && !picker.hidden) return true;
    var ps = document.getElementById('ps__widget');
    if (ps && !holding) { var r = ps.getBoundingClientRect(); if (r.width > 200 && r.height > 200 && getComputedStyle(ps).visibility !== 'hidden') return true; }
    return false;
  }

  var shown = false, timer = null;
  function tryOpen() {
    if (shown) return;
    if (somethingElseOpen()) { timer = setTimeout(tryOpen, 4000); return; }
    shown = true; clearTimeout(timer); document.removeEventListener('mouseout', onExit);
    isSubscriber(function (sub) { if (sub && !cfg.force) return; open(); });
  }
  function onExit(e) {
    if (e.relatedTarget == null && e.clientY <= 0) {
      document.removeEventListener('mouseout', onExit);
      clearTimeout(timer); tryOpen();
    }
  }
  function arm() {
    if (cfg.force) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var s = readState();
    if ((ready || cfg.force) && !s.claimed && !fromOurTexts()) holdPostscript();
    if (!cfg.force && s.claimed) return;
    if (tabWanted(s)) showTab(true);
    if (suppressedLocally()) return;
    setTimeout(warm, Math.max(0, cfg.delay - 3) * 1000);
    if (cfg.delay >= 0) timer = setTimeout(tryOpen, (cfg.force ? Math.min(cfg.delay, 1) : cfg.delay) * 1000);
    if (cfg.exitIntent && finePointer) document.addEventListener('mouseout', onExit);
  }

  /* --------------------------------------------------------------- elements */
  var boxesEl = root.querySelector('[data-match-boxes]');
  var boxes   = root.querySelectorAll('[data-match-box]');
  var dots    = root.querySelectorAll('.sbs-match__dots i');
  var autoEl  = root.querySelector('[data-match-auto]');
  var claimEl = root.querySelector('[data-match-claim]');
  var live    = root.querySelector('[data-match-live]');
  var won = false, claimed = false;
  var picks = [];                       // box numbers opened this round
  var keyboardUser = false;
  root.addEventListener('keydown', function () { keyboardUser = true; }, true);
  root.addEventListener('pointerdown', function () { keyboardUser = false; }, true);
  function setState(s) { root.setAttribute('data-match-state', s); }

  // The pair for this visit: one of the in-stock shoes from the config list, kept after a win so a reopen shows it.
  var shoes = [];
  try { shoes = JSON.parse(root.getAttribute('data-match-shoes') || '[]').filter(Boolean); } catch (e) {}
  var shoe = readState().shoe || (shoes.length ? shoes[Math.floor(Math.random() * shoes.length)] : '');

  /* --------------------------------------------- lazy images + fonts (once) */
  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    var imgs = root.querySelectorAll('img[data-match-src]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].src = imgs[i].getAttribute('data-match-src'); imgs[i].removeAttribute('data-match-src'); }
    if (shoe) { var pre = new Image(); pre.src = shoe; }
    // The card's display + label faces; the site does not load either. Falls back to Impact / the system mono.
    var f = document.createElement('link');
    f.rel = 'stylesheet'; f.href = 'https://fonts.googleapis.com/css2?family=Anton&family=IBM+Plex+Mono:wght@500;600;700&display=swap';
    f.onload = loadFaces;                                          // fetch the files now, not on first paint
    document.head.appendChild(f);
  }
  function loadFaces() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all([document.fonts.load('400 32px Anton'), document.fonts.load("700 12px 'IBM Plex Mono'")]).catch(function () {});
  }
  // Open once the logo and the display face are in (max 1.2 s), so the headline never paints in a fallback first.
  function logoReady(cb) {
    var img = root.querySelector('.sbs-match__logo'), done = false, left = 2, finish = function () { if (!done) { done = true; cb(); } };
    function one() { if (--left <= 0) finish(); }
    setTimeout(finish, 1200);
    loadFaces().then(one, one);
    if (!img) return one();
    if (img.decode) img.decode().then(one, one);
    else if (img.complete) one(); else img.onload = img.onerror = one;
  }

  /* ------------------------------------------------------ scroll lock (html) */
  var lockPad = '';
  function lockScroll() {
    var de = document.documentElement, sb = window.innerWidth - de.clientWidth;
    lockPad = de.style.paddingRight; de.classList.add('sbs-match-lock');
    if (sb > 0) de.style.paddingRight = sb + 'px';
  }
  function unlockScroll() { var de = document.documentElement; de.classList.remove('sbs-match-lock'); de.style.paddingRight = lockPad; }

  /* ------------------------------------------------------------ open/close */
  var opening = false;
  function open() {
    if (root.open || opening) return;
    opening = true; shown = true; clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    hideTab(); warm();
    logoReady(function () { opening = false; if (!root.open) reveal(); });
  }
  function reveal() {
    var s = readState();
    if (s.won && !won) finish(true, s.idx);
    else if (!won) resetBoxes();
    setState(won ? 'won' : 'ready');
    root.showModal(); lockScroll();
    root.focus({ preventScroll: true });
    writeState({ shown: Date.now() });
    if (won) preopenPostscript();
    emit('open', { won: won });
  }
  root.addEventListener('close', function () {
    unlockScroll();
    if (!claimed) { writeState({ dismissed: Date.now() }); emit('dismiss', { won: won, picks: picks.length }); showTab(false); }
  });
  root.addEventListener('click', function (e) {
    if (e.target === root) root.close();                           // backdrop
    if (e.target.closest('[data-match-close]')) root.close();
  });

  /* ------------------------------------------------------------------ boxes
     Tap any box: its lid lifts off and the pair rises out. The third box ends the round, and all three match:
     no skill, no wrong pick. A close before the third box starts a fresh round next time. */
  function paintDots() { for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i < picks.length); }
  function openBox(btn) {
    var img = btn.querySelector('.sbs-match__shoe');
    if (shoe && img.getAttribute('src') !== shoe) img.src = shoe;
    btn.classList.add('is-open');
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-label', 'Opened');
  }
  function resetBoxes() {
    picks = [];
    boxesEl.classList.remove('is-matched');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].classList.remove('is-open'); boxes[i].removeAttribute('aria-disabled');
      boxes[i].setAttribute('aria-label', 'Open box ' + (i + 1));
    }
    paintDots();
  }
  function pick(btn) {
    if (won || picks.length >= 3 || btn.classList.contains('is-open')) return;
    if (!picks.length) emit('start');
    picks.push(+btn.getAttribute('data-match-box'));
    openBox(btn); paintDots();
    if (live) live.textContent = picks.length < 3 ? 'Box opened. ' + (3 - picks.length) + ' to go.' : 'All three match.';
    if (picks.length === 3) {
      later(650, function () { boxesEl.classList.add('is-matched'); });
      later(2000, function () { finish(false); });
    }
  }
  for (var b = 0; b < boxes.length; b++) {
    boxes[b].addEventListener('click', function () { pick(this); });
  }
  if (autoEl) autoEl.addEventListener('click', function () {
    var shut = [];
    for (var i = 0; i < boxes.length; i++) if (!boxes[i].classList.contains('is-open')) shut.push(boxes[i]);
    shut.sort(function () { return Math.random() - .5; });
    shut.slice(0, 3 - picks.length).forEach(function (btn, k) { later(k * 320, function () { pick(btn); }); });
  });

  function finish(instant, idx) {
    if (won) return;
    won = true;
    if (instant) {
      resetBoxes();
      picks = (idx && idx.length === 3) ? idx : [1, 5, 9];
      for (var i = 0; i < picks.length; i++) { var btn = root.querySelector('[data-match-box="' + picks[i] + '"]'); if (btn) openBox(btn); }
      paintDots(); boxesEl.classList.add('is-matched');
    }
    setState('won');
    if (instant) return;
    if (!reduceMotion && navigator.vibrate) { try { navigator.vibrate([40, 30, 80]); } catch (e) {} }
    writeState({ won: Date.now(), shoe: shoe, idx: picks.slice() });
    if (live) live.textContent = 'It\'s a match. 10% off your first order is yours. We\'ll text you the code.';
    emit('reveal');
    preopenPostscript();
    if (keyboardUser && claimEl) claimEl.focus(); else root.focus({ preventScroll: true });
  }

  /* ----------------------------------------------------------------- claim
     Postscript's SDK can take several seconds to start (its phone pop-up loads in a second frame), and an open()
     made before it has its pop-up list is silently dropped. So Claim keeps the card up ("Opening…"), re-asks
     Postscript every 2 s, and steps aside only once Postscript's frame is actually drawn (still hidden by the
     hold, but sized). After 10 s with nothing, the card stays up and asks them to tap again. */
  var CLAIM_WAIT = 10000, RETRY_EVERY = 2000;
  function postscriptShowing() {
    var fs = document.querySelectorAll('iframe[src*="postscript.io"]'), vw = window.innerWidth, vh = window.innerHeight;
    for (var i = 0; i < fs.length; i++) {
      var r = fs[i].getBoundingClientRect();
      if (r.width > vw * 0.5 && r.height > vh * 0.5) return true;
    }
    return false;
  }
  function revealPostscript() {
    claimed = true;
    writeState({ claimed: Date.now() });
    hideTab();
    window.sbsPsHandoff = true; unhideFrame();
    releaseHold(); root.close(); root.classList.remove('is-claiming');
  }
  claimEl.addEventListener('click', function (e) {
    e.preventDefault();
    if (root.classList.contains('is-claiming')) return;
    var note = root.querySelector('[data-match-setup-note]'); if (note) note.hidden = true;
    root.classList.add('is-claiming');
    emit('claim', { via: preopened ? 'postscript-preopened' : 'postscript-popup' });
    var t0 = Date.now(), lastAsk = 0;
    if (!preopened && psOpen()) { preopened = true; lastAsk = t0; }
    (function check() {
      if (!root.open) return;
      if (postscriptShowing()) return revealPostscript();
      var now = Date.now();
      if (now - t0 > CLAIM_WAIT) {                                 // never close onto nothing: keep the card, ask again
        root.classList.remove('is-claiming');
        if (note) note.hidden = false;
        emit('claim-failed');
        return;
      }
      if (now - lastAsk > RETRY_EVERY && psOpen()) { preopened = true; lastAsk = now; }
      requestAnimationFrame(check);
    })();
  });

  /* ------------------------------------------------- reopen tab (bottom left) */
  var tab = document.querySelector('[data-match-tab]');
  function tabWanted(s) {
    if (!tab || s.claimed || !s.dismissed || fromOurTexts()) return false;
    if (!ready && !cfg.force) return false;
    return !(s.tabHidden && Date.now() - s.tabHidden < cfg.cooldownDays * 864e5);
  }
  function showTab(checkSubscriber) {
    if (!tab || claimed || (!ready && !cfg.force)) return;
    tab.setAttribute('data-match-won', (won || readState().won) ? 'true' : 'false');
    function show() { tab.hidden = false; tab._queueTuck && tab._queueTuck(); }
    if (!checkSubscriber) return show();
    isSubscriber(function (sub) { if (!sub) show(); });
  }
  function hideTab() { if (tab) tab.hidden = true; }
  if (tab) {
    tab.querySelector('[data-match-tab-open]').addEventListener('click', function () { emit('tab-open'); if (!root.open) open(); });
    tab.querySelector('[data-match-tab-close]').addEventListener('click', function () { writeState({ tabHidden: Date.now() }); hideTab(); emit('tab-hide'); });
    window.addEventListener('postscriptReady', function () { isSubscriber(function (sub) { if (sub) hideTab(); }); });
    // Never sit on a buy button: tuck off the edge while overlapping add-to-cart, the sticky buy bar, checkout or the
    // floating cart.
    var BUY = 'form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], .shopify-payment-button, ' +
              'shopify-accelerated-checkout, [class*="sticky"] button, [name="checkout"], [class*="floating-cart"]';
    var tq = false;
    function overlaps(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
    function tuck() {
      tq = false; if (tab.hidden) return;
      // offset* ignore the tuck transform, so this is where the tab sits when it is showing.
      var l = tab.offsetLeft, t = tab.offsetTop, pad = { left: l - 10, right: l + tab.offsetWidth + 10, top: t - 10, bottom: t + tab.offsetHeight + 10 };
      var hit = false, els = document.querySelectorAll(BUY);
      for (var i = 0; i < els.length && !hit; i++) { var b = els[i].getBoundingClientRect(); if (b.width && b.height && overlaps(pad, b)) hit = true; }
      tab.classList.toggle('is-tucked', hit);
    }
    function queueTuck() { if (!tq) { tq = true; requestAnimationFrame(tuck); } }
    window.addEventListener('scroll', queueTuck, { passive: true });
    window.addEventListener('resize', queueTuck);
    tab._queueTuck = queueTuck;
  }

  // QA: ?sbs_match=1 forces it open from a fresh start (even while switched off); SBS_MATCH.reset() clears the visitor memory.
  window.SBS_MATCH = {
    open: function () { if (!root.open) open(); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  arm();
})();
